import styled from "styled-components";
import css from "@styled-system/css";

import Flex from "components/core/Grid/Flex";

export const OurCompaniesList = styled(Flex)(
  css({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",

    "> :nth-child(n)": {
      marginBottom: 4,
    },
  }),
);

export const CompanyCard = styled(Flex)(
  css({
    bg: "paleGrey",
    cursor: "pointer",
    borderRadius: "8px",
    flexDirection: "column",
    width: "100%",
    height: "296px",
    wordWrap: "break-word",
    overflow: "hidden",
    transition: "box-shadow ease-out .2s",
    marginRight: "5px",
    "&:hover": {
      boxShadow: "0px 12px 22px rgba(0, 0, 0, 0.12);",
      "> div": {
        borderColor: "white",
      },
    },
    img: {
      borderRadius: "5px 5px 0 0",
      height: "106px",
      objectFit: "contain",
      width: "100%",
      padding: "10px",
    },
  }),
);

export const CompanyInfo = styled(Flex)(
  css({
    flex: 1,
    padding: 3,
    width: "100%",
    borderRadius: "5px",
    flexDirection: "column",
    borderWidth: "0 1px 1px 1px",
    borderStyle: "solid",
    borderColor: "transparent",
    h1: {
      mb: 0,
      fontSize: 2,
      lineHeight: 1.4,
      fontWeight: "600",
      fontFamily: "heading",
      color: "primaryColor",
    },
    h2: {
      mt: 1,
      mb: 2,
      fontSize: 1,
      lineHeight: 1.4,
      fontFamily: "text",
      color: "primaryColor",
    },
    p: {
      mb: 0,
      fontSize: 1,
      color: "gray",
      lineHeight: 1.6,
      fontFamily: "text",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      position: "relative",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "-webkit-line-clamp": "5",
      "-webkit-box-orient": "vertical",
    },
  }),
);
